import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateTutorialVideoCount } from '../../connection/greenroom';
import { GreenroomState } from '../../stores/types/types';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import * as ModalActions from '../../stores/actions/modal';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';

interface TutorialVideoProps {
    title: string;
    video: string;
    type?: string;
    hasHeader?: boolean;
}

export default function TutorialVideo(props: TutorialVideoProps) {
	const dispatch = useDispatch();
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const {
		hasHeader = false,
		title,
		type = 'right-corner',
		video,
	} = props;

	const getClassName = () => {
		if (type === 'right-corner') {
			return 'tutorial-video-modal-right-corner';
		}
		return 'tutorial-video-modal';
	};

	const updateTutorialSeen = async () => {
		if (token) {
			const response = await UpdateTutorialVideoCount(token);

			dispatch({
				type: 'UPDATE_TOKEN_MANUALLY',
				payload: response.token,
			});
		}
	};

	const closeModal = () => {
		dispatch(ModalActions.setModalState({
			modalOpen: false,
			modalTemplate: hasHeader
				? MODAL_TEMPLATES.HELP_MENU_TUTORIAL_VIDEO
				: MODAL_TEMPLATES.PRESENTER_ONBOARDING_TUTORIAL_VIDEO,
		}));
	};

	useEffect(() => {
		const wistiaScript = document.createElement('script');
		wistiaScript.async = true;
		wistiaScript.src = 'https://fast.wistia.net/assets/external/E-v1.js';
		document.body.appendChild(wistiaScript);
		updateTutorialSeen()
			.catch((error) => console.error(error));
	}, []);

	return (
        <div className={getClassName()}>
            <div className="tutorial-video-body">
                {(
                    <div
                        className="tutorial-video-close-icon"
                        onClick={closeModal}
                    >
                        <Icon
                            name={ICONS.CLOSE}
                            size={24}
                            color="white"
                            className="icon-pointer"
                        />
                    </div>
                )}
                <iframe
                    src={video}
                    title={title}
                    allow="autoplay; fullscreen"
                    className="wistia_embed"
                    name="wistia_embed"
                />
            </div>
        </div>
	);
}
